import styled from 'styled-components'

import { COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const Description = styled.div`
  font-size: 20px;
  margin-bottom: 30px;
  margin-top: 15px;
`

export const ButtonsContainer = styled.div``

export const ConfirmButton = styled(RoundedButton)`
  width: 100%;
`

export const CancelButton = styled(RoundedButton)`
  width: 100%;
`

export const ErrorMessage = styled.div`
  color: ${COLOURS.errorText};
  margin-bottom: 30px;
`
